module.exports = __webpack_public_path__ + "img/01_Certificaciones_ISO_2018.9ee4a6fe.jpg";